<app-config-top-nav></app-config-top-nav>

<div class="departments-container">
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div class="header" *ngIf="!isLoading">
    <h2>Departments</h2>

    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Department</button>
      <button class="btn btn-primary" (click)="goToImport()">Import Departments</button>
      <button class="btn btn-secondary" (click)="openTreeModal()">View Department Tree</button>
    </div>
  </div>

  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <div class="filters-container" *ngIf="!isLoading">
      <div class="filters-row">
        <label class="filter-field search-field">
          <app-search-bar [value]="filters.searchTerm" [debounceMs]="1000" placeholder="Search department name"
            (searchChange)="onSearchTermChange($event)">
          </app-search-bar>
        </label>
      </div>
    </div>

  <div class="departments-list">
    <div *ngFor="let department of departments$ | async" class="department-row">
      <div class="department-info">
        <div class="department-name">{{ department.name }}</div>
        <div class="department-code">Code: {{ department.code }}</div>
        <div class="department-meta">
          Employees: {{ department.employeeCount || 0 }} | Job Titles: {{ department.jobTitleCount || 0 }}
        </div>
      </div>

      <div class="department-actions">
        <button class="btn edit" (click)="openEditModal(department)">Edit</button>
        <button class="btn delete" (click)="confirmDelete(department)">Delete</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="modalOpen" class="modal-backdrop">
  <div class="modal department-modal" (click)="$event.stopPropagation()">
    <h2>{{ isEditMode ? 'Edit Department' : 'New Department' }}</h2>

    <form #departmentForm="ngForm" (ngSubmit)="submitDepartment(departmentForm)">
      <label for="departmentName">Name</label>
      <input id="departmentName" type="text" [(ngModel)]="formModel.name" name="name" required />

      <label for="departmentCode">Code</label>
      <input id="departmentCode" type="text" [(ngModel)]="formModel.code" name="code" required />

      <label for="parentDepartment">Parent Department</label>
      <select id="parentDepartment" [(ngModel)]="formModel.parentDepartmentId" name="parentDepartment">
        <option [ngValue]="null">-- None --</option>
        <option *ngFor="let dep of departments$ | async" [value]="dep.id">
          {{ dep.name }}
        </option>
      </select>

      <div class="modal-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary">{{ isEditMode ? 'Update' : 'Create' }}</button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="deleteConfirmOpen" class="modal-backdrop">
  <div class="modal confirm-modal" (click)="$event.stopPropagation()">
    <h2>Delete Department</h2>
    <p class="modal-text">
      Are you sure you want to delete <strong>{{ departmentToDelete?.name }}</strong>?
    </p>

    <div class="modal-buttons confirm-buttons">
      <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="deleteDepartment()">Delete</button>
    </div>
  </div>
</div>

<div *ngIf="treeModalOpen" class="full-tree-modal" (click)="closeTreeModal()">
  <div class="tree-modal-content" (click)="$event.stopPropagation()">
    <div class="tree-modal-header">
      <h3>Department Tree</h3>
      <button class="btn btn-secondary" (click)="closeTreeModal()">Close</button>
    </div>
    <div #treeContainer class="tree-container"></div>
  </div>
</div>

<div *ngIf="departmentDetailsModalOpen" class="modal-backdrop department-details-backdrop"
  (click)="closeDepartmentDetailsModal()">
  <div class="modal department-details-modal" (click)="$event.stopPropagation()">
    <h2>{{ departmentDetails?.name || 'Department Details' }}</h2>

    <div class="department-detail-info">
      <p><strong>Code:</strong> {{ departmentDetails?.code }}</p>
      <p *ngIf="departmentDetails?.parentDepartment">
        <strong>Parent:</strong> {{ departmentDetails?.parentDepartment?.name }}
      </p>

      <h3>Employees ({{ departmentDetails?.employees?.length || 0 }})</h3>

      <div class="employees-list" *ngIf="departmentDetails?.employees?.length">
        <div *ngFor="let emp of departmentDetails?.employees" class="employee-row">
          <span>{{ emp.firstName }} {{ emp.lastName }}</span>
        </div>
      </div>

      <p *ngIf="!departmentDetails?.employees?.length">No employees</p>
    </div>

    <div class="modal-buttons">
      <button class="btn btn-secondary" (click)="closeDepartmentDetailsModal()">Close</button>
    </div>
  </div>
</div>

<div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
  <img class="icon" alt="icon" />
  <span>{{ toastMessage }}</span>
</div>